import { IScope } from "angular";
import { RecordDataSource } from "../../../../records/grids";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { ProgressivesContext } from "../../model/progressivesContext";

const gridId = Symbol("progressiveDailyReadingsMachine");
const url = "/api/machines/progressives/ProgressiveDailyMachine";
export class DailyReadingsMachinesViewController {
  static $inject = [
    "progressivesContext",
    "$scope",
    GridSettingsServiceName,
    ServerUtilityName,
    ColumnDefinitionServiceName,
  ];

  public readonly gridDataSource: RecordDataSource;
  public readonly columns: ColDef[];
  public readonly gridSettings: IGridSettings;
  public defaultQuery: IQuery | undefined;

  constructor(
    private readonly progressivesContext: ProgressivesContext,
    $scope: IScope,
    gridSettingsService: GridSettingsService,
    serverUtility: ServerUtility,
    columnDefinitionService: ColumnDefinitionService
  ) {
    $scope.$watch(
      () => progressivesContext.date,
      () => {
        if (!this.progressivesContext.date) return;
        this.defaultQuery = {
          ProgressiveDailyPeriodDate: this.progressivesContext.date,
        };
      }
    );

    this.gridDataSource = new RecordDataSource(serverUtility, url);
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    this.columns = [
      columnDefinitionService.getNumberColDef({ field: "Id", hide: true }),
      columnDefinitionService.getDateColDef({
        field: "ProgressiveDailyPeriodDate",
        header: "Date",
      }),
      columnDefinitionService.getStringColDef({
        field: "ManufacturerName",
        header: "Manufacturer",
      }),
      columnDefinitionService.getStringColDef({ field: "SerialNumber" }),
      columnDefinitionService.getStringColDef({ field: "SlotNumber" }),
      columnDefinitionService.getStringColDef({ field: "Section" }),
      columnDefinitionService.getStringColDef({ field: "Bank" }),
      columnDefinitionService.getStringColDef({ field: "Slot" }),
      columnDefinitionService.getStringColDef({ field: "Location" }),
      columnDefinitionService.getBooleanColDef({ field: "Complete" }),
      columnDefinitionService.getNumberColDef({ field: "Readings" }),
      columnDefinitionService.getNumberColDef({ field: "RequiredReadings" }),
    ];
  }
}
